import { ShellModel } from '../../shell/data-store';

export class StallionDetailsModel extends ShellModel {
  id: number;
  image: Array<string>;
  shortDescription: string;
  shortDescription2: string;
  fullDescription: string;
  disciplines: Array<string>;

  semenExportTo: string;
  specialties: string[] = [];
  
  owner: {
    image: string;
    name: string;
    web: string;
    handle: string;
    facebook: string;
    email: string;
    mobile: string;
    description: string;
    latlng: string;
  };
  name: string;
  breedingRegister: string;

  location: {
    address: string;
    city: string;
    ZipCode: string;
    latlng: string;
    mapImage: string;
  };
  color: Array<string>;
  geneticTesting: string;
  semen: Array<string>;
  breedingFee: string;
  breedingFeeCurrency: string;
  yearOfBirth: string;
  height: string;
  breedSertification: Array<string>;
  paidIn: string;
  success: string;

 
  constructor() {
    super();
  }
}
